import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import { METRIC, HYBRID, MINUTE_KM, MINUTE_MI, METERS_PER_SECOND, SHORT } from '../constants'

export function getPaceTo ({ to, system }) {
  if (to) { return to }
  return (system === METRIC || system === HYBRID) ? MINUTE_KM : MINUTE_MI
}

export function formatPace ({ from = METERS_PER_SECOND, unit = SHORT, digits = 0, to: _to, system, ...rest } = {}) {
  const to = getPaceTo({ from, to: _to, system })
  return formatUnit({ ...rest, from, to, unit, digits })
}

export function paceFormatter ({ intl, locale, system } = {}) {
  return ({ ...options }) => formatPace({ ...options, intl, locale, system })
}

export class FormattedPace extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    from: PropTypes.oneOf([ METERS_PER_SECOND, MINUTE_KM, MINUTE_MI ]),
    to: PropTypes.oneOf([ MINUTE_KM, MINUTE_MI ]),
    clockDisplay: PropTypes.bool,
  };

  static defaultProps = {
    from: METERS_PER_SECOND,
    unit: SHORT,
    digits: 0,
    clockDisplay: false,
  };

  render () {
    const { to: _to, ...rest } = this.props
    const to = getPaceTo({ to: _to, system: this.context.system })
    return React.createElement(FormattedUnit, { ...rest, to })
  }
}
